import { Box, Text } from '@wix/design-system';
import React, { useCallback, useEffect, useMemo } from 'react';
import { convertElementStatusToBooleanStatus } from '../../utils/convert-element-statuts-to-boolean-status';
import { useDeepCompare } from '../../utils/use-deep-compare';
import { RuleElementListHeader } from '../rule-element/rule-element-list-header';
export const RuleElementGroupedList = _ref => {
  let {
    groups,
    openImageElement,
    showSummary = true,
    setIsLoading,
    setShowLoader,
    openNextElement,
    headerTitle
  } = _ref;
  const altImagesRules = groups.flatMap(_ref2 => {
    let {
      elements
    } = _ref2;
    return elements.map(element => ({
      ...element,
      contentComponent: undefined
    }));
  });
  const memoizedElements = useDeepCompare(altImagesRules);
  const completedSize = useMemo(() => memoizedElements.filter(rule => convertElementStatusToBooleanStatus(rule.status)).length, [memoizedElements]);
  const total = useMemo(() => memoizedElements.length, [memoizedElements]);
  const handleCollapseAnimationEnd = useCallback(() => {
    setShowLoader(false);
    setIsLoading == null || setIsLoading(false);
  }, [setIsLoading, setShowLoader]);
  useEffect(() => {
    openNextElement(memoizedElements, openImageElement, handleCollapseAnimationEnd);
    // TODO: remove when openImageElement re-render issue is fixed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memoizedElements, handleCollapseAnimationEnd, openNextElement]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, showSummary && /*#__PURE__*/React.createElement(RuleElementListHeader, {
    completedSize: completedSize,
    title: headerTitle,
    totalSize: total
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1"
  }, groups.map(_ref3 => {
    let {
      id,
      name,
      elements
    } = _ref3;
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "SP2",
      key: id,
      paddingBottom: "SP2"
    }, name !== '' && /*#__PURE__*/React.createElement(Text, {
      maxLines: 2,
      size: "tiny",
      ellipsis: true,
      secondary: true
    }, name), /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "SP1"
    }, elements.map(_ref4 => {
      let {
        contentComponent
      } = _ref4;
      return contentComponent;
    })));
  })));
};
//# sourceMappingURL=rule-element-grouped-list.js.map